export enum FabricConnectionCreationRole {
  ClusterAdmin = 'cluster-admin',
  TeamAdmin = 'team-admin',
  None = ''
}
